import {IFilterFunction} from "angular";
import {Condition} from "../models/OrderConditions";

export const ConditionPipeId = "tfCondition";

export function conditionPipe(): IFilterFunction {
    return (value: Condition | null) => {
        if (value == null) {
            return null;
        }
        switch (value) {
            case Condition.GREATER:
                return ">";
            case Condition.GREATER_OR_EQUAL:
                return "\u2265";
            case Condition.LESS:
                return "<";
            case Condition.LESS_OR_EQUAL:
                return "\u2264";
            default:
                return value;
        }
    };
}
